<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
		 {{#if isNewElement}}
			{{TR "Neues Element"}}
		{{else}}
			{{TR "Element bearbeiten"}}
		{{/if}}
	</h4>
</div>
<div class="modal-body">
	{{#unless isCustomElement}}
	<div class="row">
		<div class="col-sm-12">
			<div class="checkbox checkbox-primary">
				<input id="js-toggle-visibility" name="cb-only-this-device" type="checkbox" {{#if isVisible}}checked="checked"{{/if}}>
				<label for="js-toggle-visibility"><strong>{{TR "Element einblenden"}}</strong></label>
			</div>
		</div>
	</div>
	{{/unless}}
	{{#if isVisible}}
		{{#if isNewElement}}
			<div class="panel-group" id="accordion">
				{{#each editModes}}
				<div class="panel panel-default">
					<div class="panel-heading" >
						<h4 class="panel-title">
							<a id="{{id}}" class="js-toggle-element-type" href="#collapse{{@index}}"
								data-toggle="collapse" data-parent="#accordion" >
								{{title}}
							</a>
						</h4>
					</div>
					<div id="collapse{{@index}}" class="panel-collapse collapse{{#if active}} in{{/if}}">
						<div class="panel-body">
							{{> (lookup . 'template') this.data}}
						</div>
					</div>
				</div>
				{{/each}}
			</div>
		{{else}}
			{{#SWITCH  elementType}}
				{{#CASE 'value'}}
					{{> ADD_CUSTOM_VALUE  valueConfig}}
				{{/CASE}}
				{{#CASE 'text'}}
					{{> ADD_CUSTOM_TEXT}}

				{{/CASE}}
			{{/SWITCH}}
		{{/if}}
	{{/if}}
</div>
<div class="modal-footer">
	{{#if canDelete}}
	<button id="js-delete" class="btn btn-white pull-left" >{{TR "Löschen"}}</button>
	{{/if}}
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button id="js-save" class="btn btn-primary" {{#unless configValid}}disabled{{/unless}} >{{TR "Speichern"}}</button>
</div>
